import { toArray } from 'lodash'
import { mapLanguage } from 'Lib/i18nMiddleware'
import { SET_LANGUAGE } from './config'

export const SERVICE_EXTENSIONS_FETCH_LIST_REQUEST =
  'SERVICE_EXTENSIONS::FETCH_LIST_REQUEST'
export const SERVICE_EXTENSIONS_FETCH_LIST_FAIL =
  'SERVICE_EXTENSIONS::FETCH_LIST_FAIL'
export const SERVICE_EXTENSIONS_FETCH_LIST_SUCCESS =
  'SERVICE_EXTENSIONS::FETCH_LIST_SUCCESS'

const initialState = { list: [], default: [], fetching: false }

export const fetchServiceExtensionsList = () => ({
  type: SERVICE_EXTENSIONS_FETCH_LIST_REQUEST,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SERVICE_EXTENSIONS_FETCH_LIST_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case SERVICE_EXTENSIONS_FETCH_LIST_SUCCESS: {
      return {
        ...state,
        list: toArray(action.data).map(mapLanguage(action.lang)),
        default: toArray(action.data),
        fetching: false,
      }
    }
    case SERVICE_EXTENSIONS_FETCH_LIST_FAIL: {
      return {
        ...state,
        list: [],
        fetching: false,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        list: state.default.map(mapLanguage(action.payload.lang)),
      }
    }
    default:
      return state
  }
}

export default reducer
